<template>
  <div>
    <card class="card-map">
      <div class="map">
        <l-map
          :zoom="zoom"
          :center="center"
          :options="mapOptions"
          style="height: 100%"
          @update:center="centerUpdate"
          @update:zoom="zoomUpdate"
        >
          <l-tile-layer :url="url" :attribution="attribution" />
          <l-marker
            v-for="marker in markers"
            :key="marker.id"
            :lat-lng="marker.coordinates"
          >
            <l-popup>
              <b>Site Name: </b> {{ marker.name }} <br /><b>Site Type: </b>
              {{ marker.site_type }} <br /><b>Site Address: </b>
              {{ marker.address }} <br /><b>City: </b> {{ marker.city }}
              <br /><b>State: </b> {{ marker.state }}
              <!-- <br><a href="#" @click="manageSite(marker.id)" class="btn btn-success"><span>Manage Site</span></a> -->
              <br /><button
                type="button"
                class="btn btn-primary"
                @click="nextTab(marker)"
              >
                Select Site
              </button>
            </l-popup>
          </l-marker>
        </l-map>
      </div>
    </card>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";
import HTTP from "src/util/http-common.js";
import { EventBus } from "src/util/event-bus.js";

import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "purchase-leaflet-map",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
  },
  data() {
    return {
      markers: [
        {
          id: 1,
          siteName: "site name",
          siteType: "site type",
          coordinates: latLng(47.41322, -1.219482),
        },
        {
          id: 2,
          siteName: "site name 1",
          siteType: "site type 1",
          coordinates: latLng(47.41422, -1.250482),
        },
      ],
      zoom: 4,
      center: latLng(38.4773848, -100.5631407),
      url: "https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=UFBSrAyot6dnYZZr7HvR",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 11.5,
      currentCenter: latLng(38.4773848, -100.5631407),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
    };
  },
  created() {
    let loader = this.$loading.show();
    HTTP.get("api/v1/site/list", {
      params: {
        page: 1,
        page_size: 200,
        is_purchasing: true,
      },
    })
      .then((response) => {
        var data = response.data.results;
        for (var i = 0; i < data.length; i++) {
          data[i].coordinates = latLng(data[i].latitude, data[i].longitude);
        }
        this.markers = data;
        loader.hide();
      })
      .catch((err) => {
        console.log(err);
        loader.hide();
      });
  },
  mounted() {
    setTimeout(function () {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    nextTab(siteInformation) {
      console.log("emitting next-tab-select-site");
      this.$emit("next-tab", siteInformation);
    },
  },
};
</script>
